import _extends from "@babel/runtime/helpers/esm/extends";
import { fieldsIBaseModelWithUser } from './base';
import { EModel } from './model';
/**
 * Enum representing possible external sources for an assistant.
 */
export let EAssistantExternalSource; // for ai-service / python

/**
 * Enum representing the possible channels for an assistant's entry point.
 */
(function (EAssistantExternalSource) {
  EAssistantExternalSource["AzureOpenAI"] = "azure-openai";
  EAssistantExternalSource["Vapi"] = "vapi";
  EAssistantExternalSource["OpenAI"] = "openai";
  EAssistantExternalSource["Luma"] = "luma";
})(EAssistantExternalSource || (EAssistantExternalSource = {}));
export let EAssistantEntryPointChannel;

/**
 * Interface for setting up the assistant vendor configuration.
 */
(function (EAssistantEntryPointChannel) {
  EAssistantEntryPointChannel["Sms"] = "sms";
  EAssistantEntryPointChannel["Voice"] = "voice";
  EAssistantEntryPointChannel["Email"] = "email";
  EAssistantEntryPointChannel["Lumabot"] = "lumabot";
  EAssistantEntryPointChannel["Internal"] = "internal";
})(EAssistantEntryPointChannel || (EAssistantEntryPointChannel = {}));
/**
 * Interface for the configuration of a vendor setup within an entry point.
 */
/**
 * Configuration for an assistant's entry point, handling text-to-speech, speech-to-text, and LLMs.
 */
/**
 * Represents the entry point configuration for an assistant.
 */
/**
 * Represents an external identifier for an assistant instance.
 */
/**
 * Interface for an assistant model.
 */
export const fieldsAssistant = _extends({}, fieldsIBaseModelWithUser, {
  analysis: {
    type: 'ID',
    ref: EModel.LargeLanguageModelPrompt
  },
  definition: {
    type: 'ID',
    ref: EModel.LargeLanguageModelPrompt
  },
  enabled: {
    type: 'Boolean'
  },
  entryPoints: {
    type: 'Object',
    array: true
  },
  externalId: {
    type: 'Object'
  },
  files: {
    type: 'ID',
    ref: EModel.LargeLanguageModelPrompt,
    array: true
  },
  name: {
    type: 'Text'
  },
  secondaryExternalId: {
    type: 'Object'
  },
  setting: {
    type: 'ID',
    ref: EModel.Setting
  },
  settings: {
    type: 'Object'
  },
  summary: {
    type: 'ID',
    ref: EModel.LargeLanguageModelPrompt
  },
  tools: {
    type: 'ID',
    ref: EModel.LargeLanguageModelPrompt,
    array: true
  },
  transfer: {
    type: 'ID',
    ref: EModel.LargeLanguageModelPrompt
  },
  virtualUser: {
    type: 'ID',
    ref: EModel.User
  }
});